<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon>call_received</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>
                {{ this.acuerdoAModificar != null ? 'Modificación' : 'Alta' }}
                de Acuerdo (NUEVO) &nbsp;&nbsp;&nbsp;
                <v-chip
                  v-if="esSupervisor"
                  color="pink"
                  label
                  text-color="white"
                  >MODO: Supervisor</v-chip
                >
              </div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <!-- {{ acuerdoAModificar }} -->
      <v-card-text>
        <v-container fluid>
          <v-row v-if="!selectedPersona" dense>
            <v-col>
              <span>Seleccione a una Persona</span>
            </v-col>
          </v-row>

          <v-row align="center" v-if="!selectedPersona">
            <v-col cols="12">
              <app-busqueda-personas
                :personaSeleccionada="setPersona"
              ></app-busqueda-personas>
            </v-col>
          </v-row>

          <v-row v-if="selectedPersona">
            <v-col>
              <span
                >Persona seleccionada &nbsp;&nbsp;&nbsp;
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      v-if="selectedPersona && selectedPersona.enListaNegra"
                      color="black"
                      >thumb_down</v-icon
                    >
                  </template>
                  <span>EN LISTA NEGRA</span>
                </v-tooltip></span
              >
            </v-col>
          </v-row>

          <v-row align="center" v-if="selectedPersona">
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.cui"
                label="CUI(L/T) "
                key="cuil"
                :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.nombreCompleto"
                label="Nombre"
                :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn color="warning" small text @click="limpiar"
                >Cancelar</v-btn
              >
            </v-col>
          </v-row>

          <!-- lista de deudas de la persona -->
          <v-container fluid v-if="selectedPersona">
            <v-card>
              <v-card-title>
                <span class="title">Créditos con Deuda</span>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  dense
                  :headers="headers"
                  :items="listDeudas"
                  :rows-per-page="pagination.itemsPerPage"
                  :options.sync="pagination"
                  v-model="listDeudasSeleccionadas"
                  :loading="loading"
                  class="elevation-1"
                  :footer-props="footer"
                  :show-select="listDeudas.length > 0"
                  item-key="id"
                >
                  <template v-slot:header.data-table-select="{ on, props }">
                    <v-checkbox
                      @change="selectAllChanged"
                      color="purple"
                      v-bind="props"
                      v-on="on"
                    ></v-checkbox>
                  </template>

                  <template v-slot:item="{ item, isSelected, select }">
                    <tr>
                      <td v-if="item.motivoNoPuedeCobrar == ''">
                        <v-simple-checkbox
                          class="caption"
                          color="green"
                          :value="isSelected"
                          @input="select($event)"
                        ></v-simple-checkbox>
                      </td>
                      <td v-else>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" dark v-on="on"
                              >warning</v-icon
                            >
                          </template>
                          <span
                            >No puede realizar un Acuerdo sobre esta deuda
                            porque: {{ item.motivoNoPuedeCobrar }}</span
                          >
                        </v-tooltip>
                      </td>

                      <td>
                        <app-acciones-comunes :personaId="model.personaId">
                        </app-acciones-comunes>
                      </td>

                      <td class="text-xs-left caption">{{ item.origen }}</td>
                      <td class="text-xs-left caption">{{ item.numero }}</td>
                      <td class="text-xs-left caption">
                        {{
                          item.detalle
                            .map((d) => d.importeCuota)
                            .reduce((a, b) => a + b, 0) | currency
                        }}
                      </td>
                      <td class="text-xs-left caption">
                        {{
                          item.detalle
                            .map((d) => d.importePunitorios)
                            .reduce((a, b) => a + b, 0) | currency
                        }}
                      </td>
                      <td class="text-xs-left caption">
                        {{
                          item.detalle
                            .map((d) => d.importeCargos)
                            .reduce((a, b) => a + b, 0) | currency
                        }}
                      </td>
                      <td class="text-xs-left caption">
                        {{
                          item.detalle
                            .map(
                              (d) =>
                                d.importeCuota +
                                d.importePunitorios +
                                d.importeCargos
                            )
                            .reduce((a, b) => a + b, 0) | currency
                        }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.vectorMora }}
                      </td>
                      <td class="text-xs-left caption">
                        <v-chip small :color="item.empresaColor" label dark>{{
                          item.empresa
                        }}</v-chip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-container>

          <!-- detalle del acuerdo -->
          <v-container fluid v-if="listDeudasSeleccionadas.length > 0">
            <v-row dense>
              <v-col cols="2">
                Total a Reestructurar
                <v-chip color="green" large label outlined>
                  {{ totalSeleccionadoDeuda | currency }}</v-chip
                >
              </v-col>
              <v-col cols="2">
                Punitorios
                <v-chip color="green" label outlined>
                  {{ totalSeleccionadoPunitorios | currency }}</v-chip
                >
              </v-col>
              <v-col cols="2">
                Cargos Cbrz.
                <v-chip color="green" label outlined>
                  {{ totalSeleccionadoCargos | currency }}</v-chip
                >
              </v-col>
              <v-col cols="2" v-if="model.generarAnticipo">
                Anticipo
                <v-chip color="orange" label outlined>
                  {{ totalAnticipo | currency }}</v-chip
                >
              </v-col>
              <v-col cols="2">
                Total Acuerdo
                <v-chip color="green" large label outlined>
                  {{ totalAcuerdoConDescuentos | currency }}</v-chip
                >
              </v-col>

              <v-spacer></v-spacer>
              <v-btn @click="alta(true)" color="pink" dark>
                Calcular Acuerdo</v-btn
              >
            </v-row>

            <div v-if="acuerdoCalculado">
              <v-row dense>
                <v-col cols="2">
                  <v-checkbox
                    label="Condonar Deuda"
                    v-model="model.condonarDeuda"
                  >
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">help_outline</v-icon>
                        </template>
                        Permite ingresar un monto a condonar de Intereses
                        Punitorios y/o Cargos de Cobranza de los Créditos con
                        Deuda
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="2" v-if="model.condonarDeuda && esSupervisor">
                  <v-text-field
                    v-model="model.importeCondonadoPunitorios"
                    label="$ a Descontar de Punitorios"
                    :error="validadorImporteCondonadoPunitorios != ''"
                    :error-messages="validadorImporteCondonadoPunitorios"
                  />
                </v-col>
                <v-col cols="2" v-if="model.condonarDeuda && esSupervisor">
                  <v-text-field
                    v-model="model.importeCondonadoCargos"
                    label="$ a Descontar de Cargos"
                    :error="validadorImporteCondonadoCargos != ''"
                    :error-messages="validadorImporteCondonadoCargos"
                  />
                </v-col>
                <v-col cols="2" v-if="model.condonarDeuda && esSupervisor">
                  <v-text-field
                    v-model="totalAcuerdoConDescuentos"
                    label="Total Acuerdo"
                    prefix="$"
                    :disabled="true"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="2">
                  <v-checkbox
                    label="Generar Anticipo por"
                    v-model="model.generarAnticipo"
                  />
                </v-col>
                <v-col cols="2" v-if="model.generarAnticipo">
                  <v-text-field
                    v-model="model.importeAnticipoCuota"
                    label="$ a Cuota"
                  />
                </v-col>
                <v-col cols="2" v-if="model.generarAnticipo">
                  <v-text-field
                    v-model="model.importeAnticipoPunitorios"
                    label="$ a Punitorios"
                  />
                </v-col>
                <v-col cols="2" v-if="model.generarAnticipo">
                  <v-text-field
                    v-model="model.importeAnticipoCargos"
                    label="$ a Cargos"
                  />
                </v-col>
                <v-col cols="2" v-if="model.generarAnticipo">
                  <v-text-field
                    v-model="model.fechaAnticipo"
                    label="para el Día"
                    type="date"
                  />
                </v-col>
              </v-row>

              <v-row align="center" dense>
                <v-col cols="3"><h2>Seleccione una Opción</h2></v-col>
              </v-row>

              <v-row align="center" dense v-if="opcionesCuotas">
                <v-col cols="2">
                  <v-radio-group row v-model="model.cantidadCuotas">
                    <v-radio
                      v-for="item in opcionesCuotas"
                      @change="setCuotaSeleciconada(item)"
                      :key="item.indice"
                      :label="
                        item.cuota +
                        ' cuotas de $ ' +
                        item.deudaOrigen.toFixed(2)
                      "
                      :value="item.cuota"
                    ></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="3">
                  <v-row>
                    <v-autocomplete
                      v-model="model.primerVencimiento"
                      :items="opcionesVencimientos"
                      item-text="descripcion"
                      item-value="id"
                      label="El 1er Vencimiento será el "
                      :menu-props="{ minWidth: '200' }"
                    ></v-autocomplete>
                  </v-row>
                  <v-row>
                    <v-autocomplete
                      v-model="model.tipoMedioCobroId"
                      :items="listMediosCobro"
                      item-text="descripcion"
                      item-value="id"
                      label="El cobro del acuerdo será mediante"
                      :menu-props="{ minWidth: '200' }"
                    ></v-autocomplete>
                  </v-row>
                  <v-row v-if="model.tipoMedioCobroId == 2" no-gutters>
                    <v-col cols="12">
                      <app-datos-debito-credito
                        :standAloneMode="false"
                        :personaId="model.personaId"
                        :cuentaSeleccionada="model.cuentaDebito"
                        :creditoId="operacionReferencia.id"
                        :situacionLaboralActividadId="
                          operacionReferencia.infoMedioCobro
                            .situacionLaboralActividadId
                        "
                        v-if="operacionReferencia"
                      ></app-datos-debito-credito>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="4">
                  <v-card>
                    <v-card-title>Medio de Cobro Actual</v-card-title>
                    <v-card-text>
                      <v-list>
                        <v-list-item
                          v-for="deuda in listDeudasSeleccionadas"
                          :key="deuda.id"
                        >
                          <div
                            v-if="deuda.infoMedioCobro.medioCobroId == 1"
                            class="text-h5 mb-1"
                          >
                            Pago Voluntario
                          </div>
                          <div
                            v-if="deuda.infoMedioCobro.medioCobroId == 2"
                            class="text-h5 mb-1"
                          >
                            <v-row class="text-h5 mb-1">
                              Débito en Cuenta
                            </v-row>
                            <v-row class="text-h6 mb-1">
                              {{ deuda.infoMedioCobro.infoDebitoCbu }}
                            </v-row>
                          </div>
                          <div v-if="deuda.infoMedioCobro.medioCobroId == 3">
                            <v-row class="text-h5 mb-1">
                              Tarjeta de Débito
                            </v-row>
                            <v-row class="text-h6 mb-1">
                              {{ deuda.infoMedioCobro.infoDebitoTarjeta }}
                            </v-row>
                          </div>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <!-- <v-row align="center" dense>
              <v-col cols="1"> Saldo en </v-col>
              <v-col cols="1">
                <v-text-field
                  v-model="model.cantidadCuotas"
                  label=""
                  type="number"
                />
              </v-col>
              <v-col cols="2"> cuotas de {{ importeCuota | currency }} </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="model.primerVencimiento"
                  label="con 1er. vto el"
                  type="date"
                />
              </v-col>
            </v-row> -->

              <v-row align="center" dense> </v-row>
            </div>
          </v-container>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="acuerdoCalculado && !datosModificados">
        <v-chip
          color="red"
          text-color="white"
          v-if="motivoAprobacion !== ''"
          label
          >EXEPCION POR: {{ motivoAprobacion }}</v-chip
        >
        <v-spacer />
        <v-btn dark @click="alta(false)" color="red" v-if="requiereAprobacion">
          Solicitar Excepcion</v-btn
        >
        <v-btn
          @click="alta(false)"
          color="success"
          :disabled="requiereAprobacion"
        >
          Confirmar Alta</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { format } from 'date-fns';
import { Decimal } from 'decimal.js';

import { mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
    loading: false,
    saving: false,
    selectedPersona: null,
    listDeudas: [],
    listDeudasSeleccionadas: [],
    fecha: format(new Date(), 'YYYY-MM-DD'),
    totalSeleccionado: 0,
    totalSeleccionadoDeuda: 0,
    totalSeleccionadoPunitorios: 0,
    totalSeleccionadoCargos: 0,
    importeCuota: 0,
    tipoMedioPagoId: 0,
    listMediosCobro: [],
    opcionesCuotas: [],
    opcionesVencimientos: [],
    acuerdoCalculado: false,
    cbu: '',
    diaCobroId: 0,
    operacionReferencia: null,
    motivoAprobacion: '',
    datosModificados: true,

    model: {
      personaId: null,
      importeCargosExtra: 0,
      generarAnticipo: false,
      importeAnticipoCuota: 0,
      importeAnticipoPunitorios: 0,
      importeAnticipoCargos: 0,
      fechaAnticipo: null,
      cantidadCuotas: 0,
      primerVencimiento: null,
      deudas: [],
      tipoMedioCobroId: 0,
      cuentaDebito: {},
      condonarDeuda: false,
      importeCondonadoPunitorios: 0,
      importeCondonadoCargos: 0,
    },
    pagination: {
      // definición de paginación
      sortDesc: [true],
      sortBy: [''],
      page: 1,
      itemsPerPage: 5,
    },
    footer: {
      showFirstLastPage: true,
      itemsPerPageOptions: [5, 10, 20, 50],
    },
    totalItems: 0, // va afuera de pagination
    headers: [
      // definición de columnas
      { text: 'Ver', value: 'accion', width: 80, sortable: false },
      { text: 'Origen del Crédito', value: 'origen' },
      { text: 'Número', value: 'numero' },
      { text: 'Deuda', value: 'deuda' },
      { text: 'Punitorios', value: 'punitorios' },
      { text: 'Cargos Cbza.', value: 'cargos' },
      { text: 'Total Adeudado', value: 'totalAdeudado' },
      { text: 'VM', value: 'vectorMora' },
      { text: 'Empresa', value: 'empresaShort', width: 100 },
    ],
    // validadorImporteCondonadoPunitorios: ''
  }),
  async created() {
    this.loadMediosCobro();
    this.model.fechaAnticipo = this.$moment(new Date()).format('YYYY-MM-DD');
    this.model.primerVencimiento = this.$moment(new Date()).format(
      'YYYY-MM-DD'
    );

    console.log('this.acuerdoAModificar');
    console.log(this.acuerdoAModificar);

    if (this.acuerdoAModificar) {
      this.model = this.acuerdoAModificar;

      // cargo a la persona
      this.selectedPersona = { id: this.model.personaId };

      // busco las deudas y selecciono las deudas incluidas
      await this.loadDeudas();

      this.alta(true);
    }
  },
  props: {
    acuerdoAModificar: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(['getActionFromLink', 'user']),
    esSupervisor: function () {
      return (
        !this.user.roles.filter((x) => x == 'Supervisor Cobranzas').length == 1
      );
    },
    requiereAprobacion: function () {
      // requiere aprobacion si:
      // - no es supervisor, y VM ==2
      // - no es supervisor, y Cuotas > 16
      // - hay cambio de medio de cobro de otro a PV

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.motivoAprobacion = '';

      if (this.esSupervisor) return false;

      if (this.operacionReferencia) {
        if (this.totalSeleccionadoDeuda > 300000) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.motivoAprobacion =
            this.motivoAprobacion + 'Monto a Reestructurar mayor a $300.000 / ';
        }

        if (this.operacionReferencia.vectorMora <= 2) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.motivoAprobacion =
            this.motivoAprobacion + 'VM menor o igula a 2 / ';
        }

        if (this.model.cantidadCuotas > 16) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.motivoAprobacion =
            this.motivoAprobacion + 'Cantidad de Cuotas Mayor a 16 / ';
        }

        // cualquier cambio a PV, si no se es supervisor, requiere autorización
        if (
          this.operacionReferencia.infoMedioCobro.medioCobroId != 1 &&
          this.model.tipoMedioCobroId == 1
        ) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.motivoAprobacion =
            this.motivoAprobacion + 'Cambio a Medio de Cobro a PV / ';
        }

        if (this.model.condonarDeuda) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.motivoAprobacion =
            this.motivoAprobacion + 'Condonación de Deuda / ';
        }

        // // condonacion de punitorios > 50%
        // if (
        //   this.model.importeCondonadoPunitorios >
        //   this.totalSeleccionadoPunitorios / 2
        // ) {
        //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        //   this.motivoAprobacion =
        //     this.motivoAprobacion + 'Condonación de Punitorios mayor al 50% / ';
        // }
        // if (
        //   this.model.importeCondonadoCargos >
        //   this.totalSeleccionadoCargos / 2
        // ) {
        //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        //   this.motivoAprobacion =
        //     this.motivoAprobacion +
        //     'Condonación de Cargos Cobranza mayor al 50% / ';
        // }
      }
      return this.motivoAprobacion !== '';
    },
    totalAcuerdo: function () {
      return new Decimal(this.totalSeleccionado).plus(
        this.model.importeCargosExtra
      );
    },
    totalAcuerdoConDescuentos: function () {
      return new Decimal(this.totalSeleccionado)
        .plus(this.model.importeCargosExtra)
        .minus(
          this.model.importeCondonadoPunitorios
            ? this.model.importeCondonadoPunitorios
            : 0
        )
        .minus(
          this.model.importeCondonadoCargos
            ? this.model.importeCondonadoCargos
            : 0
        );
    },
    totalAnticipo: function () {
      return new Decimal(this.model.importeAnticipoCuota)
        .plus(this.model.importeAnticipoPunitorios)
        .plus(this.model.importeAnticipoCargos);
    },
    validadorImporteCondonadoPunitorios: function () {
      if (!this.model.condonarDeuda || !this.model.importeCondonadoPunitorios)
        return '';
      var totalPunitorios = 0;

      for (
        let index = 0;
        index < this.listDeudasSeleccionadas.length;
        index++
      ) {
        const deuda = this.listDeudasSeleccionadas[index];
        totalPunitorios = new Decimal(totalPunitorios).plus(
          deuda.detalle
            .map((d) => d.importePunitorios)
            .reduce((a, b) => a + b, 0)
        );
      }

      if (
        new Decimal(this.model.importeCondonadoPunitorios).minus(
          totalPunitorios
        ) > 0
      )
        return 'El importe no puede superar $' + totalPunitorios.toFixed(2);
      else return '';
    },
    validadorImporteCondonadoCargos: function () {
      if (!this.model.condonarDeuda || !this.model.importeCondonadoCargos)
        return '';
      var totalCargos = 0;

      for (
        let index = 0;
        index < this.listDeudasSeleccionadas.length;
        index++
      ) {
        const deuda = this.listDeudasSeleccionadas[index];
        totalCargos = new Decimal(totalCargos).plus(
          deuda.detalle.map((d) => d.importeCargos).reduce((a, b) => a + b, 0)
        );
      }

      if (new Decimal(this.model.importeCondonadoCargos).minus(totalCargos) > 0)
        return 'El importe no puede superar $' + totalCargos.toFixed(2);
      else return '';
    },
  },
  watch: {
    acuerdoAModificarId: {
      handler() {
        console.log(this.acuerdoCacuerdoAModificaralculado);
      },
    },
    listDeudasSeleccionadas: function () {
      this.totalSeleccionado = 0;
      this.totalSeleccionadoDeuda = 0;
      this.totalSeleccionadoPunitorios = 0;
      this.totalSeleccionadoCargos = 0;

      for (
        let index = 0;
        index < this.listDeudasSeleccionadas.length;
        index++
      ) {
        const deuda = this.listDeudasSeleccionadas[index];

        this.totalSeleccionado = new Decimal(this.totalSeleccionado).plus(
          deuda.detalle
            .map((d) => d.importeCuota + d.importePunitorios + d.importeCargos)
            .reduce((a, b) => a + b, 0)
        );

        this.totalSeleccionadoDeuda = new Decimal(
          this.totalSeleccionadoDeuda
        ).plus(
          deuda.detalle.map((d) => d.importeCuota).reduce((a, b) => a + b, 0)
        );

        this.totalSeleccionadoPunitorios = new Decimal(
          this.totalSeleccionadoPunitorios
        ).plus(
          deuda.detalle
            .map((d) => d.importePunitorios)
            .reduce((a, b) => a + b, 0)
        );

        this.totalSeleccionadoCargos = new Decimal(
          this.totalSeleccionadoCargos
        ).plus(
          deuda.detalle.map((d) => d.importeCargos).reduce((a, b) => a + b, 0)
        );
      }

      this.operacionReferencia = this.listDeudasSeleccionadas.reduce(
        (prev, current) => {
          return prev.vectorMora > current.vectorMora ? prev : current;
        }
      );

      // seteo el medio de cobro en base al de la operacion
      this.model.tipoMedioCobroId =
        this.operacionReferencia.infoMedioCobro.medioCobroId;

      console.log(this.operacionReferencia.infoMedioCobro);
    },
    // 'model.cantidadCuotas': function () {
    //   this.alta(true);
    // },
    'model.generarAnticipo': function () {
      if (!this.model.generarAnticipo) {
        this.model.importeAnticipoCuota = 0;
        this.model.importeAnticipoPunitorios = 0;
        this.model.importeAnticipoCargos = 0;
      }
      this.datosModificados = true;
    },
    'model.importeCondonadoPunitorios': function () {
      this.datosModificados = true;
    },
    'model.importeCondonadoCargos': function () {
      this.datosModificados = true;
    },
    'model.tipoMedioCobroId': function () {
      if (this.model.tipoMedioCobroId != 2) this.model.cuentaDebito = {};
      //this.model.cuentaDebito.altaCuenta = false;
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    selectAllChanged(toggle) {
      this.listDeudasSeleccionadas = [];
      if (toggle) {
        for (let index = 0; index < this.listDeudas.length; index++) {
          const element = this.listDeudas[index];

          this.listDeudasSeleccionadas.push(element);
        }
      }
    },
    limpiar: function () {
      this.selectedPersona = null;
      this.listDeudas = [];
      this.listDeudasSeleccionadas = [];
      this.acuerdoCalculado = false;
      this.datosModificados = true;
      this.condonarDeuda = false;
      this.model.condonarDeuda = false;
      this.model.importeCondonadoPunitorios = 0;
      this.model.importeCondonadoCargos = 0;
      this.model.generarAnticipo = false;
    },
    setPersona(persona) {
      this.selectedPersona = persona;
      this.model.personaId = persona.personaId;
      this.loadDeudas();
    },
    async alta(simular) {
      Vue.$log.debug(this.model);
      if (!simular) {
        Vue.$log.debug('NO SIMULAR');
        if (!this.validarAlta()) return;
        Vue.$log.debug('NO SIMULAR 2');
      }

      this.loadingDeudas = true;

      this.model.deudas = [];

      var emp = 0;

      for (
        let index = 0;
        index < this.listDeudasSeleccionadas.length;
        index++
      ) {
        const deuda = this.listDeudasSeleccionadas[index];

        if (emp == 0) {
          emp = deuda.empresaId;
        } else {
          if (emp != deuda.empresaId) {
            this.alertWarning(
              'No puedes armar un mismo acuerdo con créditos de distintas empresas.'
            );
            return false;
          }
        }

        this.model.deudas.push({
          empresaId: deuda.empresaId,
          tipoDeuda: 1,
          deudaId: deuda.id,
          importeDeuda: deuda.detalle
            .map((d) => d.importeCuota)
            .reduce((a, b) => a + b, 0),
          importePunitorios: deuda.detalle
            .map((d) => d.importePunitorios)
            .reduce((a, b) => a + b, 0),
          importeCargos: deuda.detalle
            .map((d) => d.importeCargos)
            .reduce((a, b) => a + b, 0),
        });
      }

      try {
        if (simular) {
          let vm = this.listDeudasSeleccionadas.reduce((prev, current) => {
            return prev.vectorMora > current.vectorMora ? prev : current;
          });

          let cantidadCuotasAnteriores = this.acuerdoAModificar
            ? this.acuerdoAModificar.cantidadCuotas
            : -1;

          this.model.cantidadCuotas = -1;

          this.model.vectorMora = vm.vectorMora;

          var result = await http.post(
            'acuerdos/simular',
            JSON.stringify({ acuerdo: this.model })
          );
          console.log(result);
          this.opcionesCuotas = result.entity.opcionesCuotas;

          this.opcionesVencimientos = [];
          for (var i = 0; i < result.entity.opcionesVencimiento.length; i++) {
            this.opcionesVencimientos.push({
              id: result.entity.opcionesVencimiento[i],
              descripcion: this.$moment(
                result.entity.opcionesVencimiento[i]
              ).format('DD/MM/YYYY'),
            });
          }
          this.model.primerVencimiento = this.opcionesVencimientos[0].id;

          this.model.cantidadCuotas = cantidadCuotasAnteriores;

          this.acuerdoCalculado = true;
          this.datosModificados = false;
        } else {
          this.model.solicitaExcepcion = this.requiereAprobacion;
          this.model.motivoExcepcion = this.motivoAprobacion;
          this.model.altaV2 = true;

          // eslint-disable-next-line no-redeclare
          var result = await http.post(
            'acuerdos',
            JSON.stringify({ acuerdo: this.model })
          );
          Vue.$log.debug(result);

          this.alertSuccess('El Acuerdo ha sido dado de alta');
          this.limpiar();
        }
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }

      this.loadingDeudas = false;
    },
    async loadDeudas() {
      this.listDeudas = [];
      this.loadingDeudas = true;
      try {
        var result = await http.get(
          'personas/listdeudasporcobrardetallada' +
            '?empresaId=0' +
            '&id=' +
            this.model.personaId +
            '&fechaCaja=' +
            format(new Date(), 'YYYY-MM-DD')
        );

        this.listDeudas = result.list;

        // busco los datos de medio de pago
        for (let index = 0; index < this.listDeudas.length; index++) {
          const deuda = this.listDeudas[index];

          var datosMedioCobro = await http.get(
            'creditos/datosmediocobro' + '?creditoId=' + deuda.id
          );

          deuda.infoMedioCobro = datosMedioCobro;

          // veo si estoy trabajando sobre un acuerdo ya generado
          if (this.acuerdoAModificar) {
            if (
              this.acuerdoAModificar.deudas.find((x) => x.deudaId == deuda.id)
            )
              deuda.motivoNoPuedeCobrar = ''; // lo limpio para que se pueda incliir

            this.listDeudasSeleccionadas.push(deuda);
          }
        }

        // console.log(this.listDeudas);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingDeudas = false;
    },
    setCuotaSeleciconada(itemCuota) {
      this.model.cantidadCuotas = itemCuota.cuota;
    },
    async loadMediosCobro() {
      this.loading = true;
      try {
        var result = await http.get('tiposmediocobro'); // traigo todas
        this.listMediosCobro = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    validarAlta() {
      if (this.model.cantidadCuotas <= 0) {
        this.alertWarning(
          'Por favor, seleccione la cantidad de cuotas del acuerdo.'
        );
        return false;
      }

      // if (!this.model.generarAnticipo) {
      //   this.alertWarning(
      //     'Por favor, verifique el importe de Anticipo, ya que que debe ser al menos de una cuota.'
      //   );
      //   return false;
      // }

      if (this.model.generarAnticipo) {
        if (
          this.model.importeAnticipoCuota == 0 &&
          this.model.importeAnticipoPunitorios == 0 &&
          this.model.importeAnticipoCargos == 0
        ) {
          this.alertWarning(
            'Por favor, verifique los montos del Antcipo, o destilde la opción si no quiere generarlo.'
          );
          return false;
        }

        // // la suma de los importes de anticipo debe ser de al menos una cuota
        // if (
        //   new Decimal(this.model.importeAnticipoCuota)
        //     .plus(this.model.importeAnticipoPunitorios)
        //     .plus(this.model.importeAnticipoCargos) <
        //   this.opcionesCuotas.find((x) => x.cuota == this.model.cantidadCuotas)
        //     .deudaOrigen
        // ) {
        //   this.alertWarning(
        //     'Por favor, verifique los montos del Antcipo,debe ser de al menos una Cuota (' +
        //       this.opcionesCuotas.find(
        //         (x) => x.cuota == this.model.cantidadCuotas
        //       ).deudaOrigen +
        //       ').'
        //   );
        //   return false;
        // }
      } else {
        this.model.importeAnticipoCuota = 0;
        this.model.importeAnticipoPunitorios = 0;
        this.model.importeAnticipoCargos = 0;
      }

      if (!this.model.tipoMedioCobroId || this.model.tipoMedioCobroId == 0) {
        this.alertWarning('Por favor, seleccione el medio de cobro.');
        return false;
      }

      return true;
    },
  },
};
</script>
